module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.894a2ede.ttf";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/fonts/roboto/Roboto-Medium.ttf
// module id = 1467
// module chunks = 0